import { useQuery } from 'react-query';
import queryGetPosTerminalsHistorics from './queries/getPosTerminalsHistorics';
import queryGetSimCardsHistorics from './queries/getSimCardsHistorics';
import queryGetUsersHistorics from './queries/getUsersHistorics';

const actionsHistorics = {
    // Sim Cards
    getSimCardsHistorics: (params, enabled) => useQuery(queryGetSimCardsHistorics(params, enabled)),

    // Pos Terminals
    getPosTerminalsHistorics: (params, enabled) => useQuery(queryGetPosTerminalsHistorics(params, enabled)),

    // Users
    getUsersHistorics: (params, enabled) => useQuery(queryGetUsersHistorics(params, enabled))
};

export default actionsHistorics;